import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

import { SPONSOR_LOGO_URL } from "@lib/globals";

import { DeleteModalParams } from "@SiteManagement/Advertisers/types/advertisers";

const DeleteModal = ({
    show,
    setShow,
    handleDelete,
    sponsor,
}: DeleteModalParams): React.JSX.Element => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            centered={true}
            className="deleteAdvertiserModal"
        >
            <Modal.Header>
                <Modal.Title>Delete Advertiser?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col lg={5}>
                        {sponsor?.logo && (
                            <img
                                src={`${SPONSOR_LOGO_URL}${sponsor?.logo}`}
                                alt={`${sponsor?.name} logo`}
                                className="sponsorLogo img-fluid"
                            />
                        )}
                    </Col>
                    <Col lg={7} className="sponsorInfo">
                        <b>Name:</b> {sponsor?.name}
                        <br />
                        <b>Link:</b> {sponsor?.link}
                        <br />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => setShow(false)}>
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        handleDelete(sponsor?.id);
                        setShow(false);
                    }}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteModal;
